import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export const cn = (...inputs: ClassValue[]) => {
	return twMerge(clsx(inputs))
}

export const formatDate = (date: string) => {
	return new Date(date).toLocaleDateString('fr-FR', {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	})
}

export const formatWhatsappMessage = ({ user, product }) => {
	let message = user ? `Bonjour, je suis ${user.name}. ` : 'Bonjour. ';

	if (product) {
		message += `Je consulte actuellement la page “${product.name}” (id: ${product.id}). J’ai une question concernant cet article.`;
	} else {
		message += `J'ai une question.`;
	}

	return encodeURIComponent(message);
}